import { render, staticRenderFns } from "./dashboard-contribution-rank.vue?vue&type=template&id=72eeeffb&scoped=true&"
import script from "./dashboard-contribution-rank.vue?vue&type=script&lang=js&"
export * from "./dashboard-contribution-rank.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-contribution-rank.vue?vue&type=style&index=0&id=72eeeffb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eeeffb",
  null
  
)

export default component.exports